import { IconButton, Tooltip } from '@mui/material';
import { FaQuestionCircle } from 'react-icons/fa';
import { Container } from './styles';

interface TitlePageProps {
  id: string;
  title: string;
  icon?: React.ReactNode;
  iconVisible?: boolean;
  onRequestOpen: () => void;
}
export default function TitlePage({ title, onRequestOpen, id, icon, iconVisible = true }: TitlePageProps) {
  return (
    <Container>
      <h1 id={id}>
        {icon} {title}
      </h1>
      {iconVisible && (
        <Tooltip title="Dúvidas? Clique aqui para um tour rápido!" disableInteractive>
          <div>
            <IconButton size="small" onClick={() => onRequestOpen()}>
              <FaQuestionCircle />
            </IconButton>
          </div>
        </Tooltip>
      )}
    </Container>
  );
}
